"use client";

import { Cards as BumbleCards, Header3, P1 } from "@bumble/ui-kit";
import styles from "./Cards.module.css";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export default function Cards({
  data
}: any) {
  const cardsToRender = data?.cards?.map((card: any) => {
    return {
      title: card?.title ?? "",
      description: card?.copy ?? "",
      image: {
        alt: card?.image?.alt ?? "Placeholder image",
        src: card?.image?.url || PLACEHOLDER_IMAGE
      },
      type: "2-up"
    };
  }) ?? [];
  const hasCards = cardsToRender.length > 0;
  if (!hasCards) {
    return null;
  }
  return <BumbleCards gridLead={<GridLead title={data?.yellowCardTitle} copy={data?.yellowCardCopy} />} cards={cardsToRender} size="desktop" type="blog" blogLayout="grid" viewMoreCta={undefined} ref={undefined} id={undefined} onScrollChange={undefined} onCardVisible={undefined} />;
}
function GridLead({
  title,
  copy
}: {
  title?: string;
  copy?: string;
}) {
  const heading = title ?? "Our values";
  const body = copy ?? "Together, we’re creating a company, a community, and a movement rooted in love, connection, and purpose. We live these values every day—within our teams, in our products, and in the impact we have on the world and the future of love.";
  return <div className={styles.grid__lead}>
      <Header3>{heading}</Header3>
      <P1>{body}</P1>
    </div>;
}